import DropZone from "react-dropzone";
import { AttachFile as AttachFileIcon } from "@mui/icons-material";

import "./styles.css";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";

interface IFileDropZone {
    multiple?: boolean;
    disabled?: boolean;
    onDropFiles?: (newFiles: File[]) => void;
}

const FileDropZone: React.FC<IFileDropZone> = (props: IFileDropZone) => {
    const strings = useStrings();
    const multiple = !Helpers.isNullOrEmpty(props.multiple)
        ? props.multiple
        : true;

    const noClick = props.disabled === true
        ? true
        : false;

    const onDropFiles = (newFiles: File[]) => {
        props.onDropFiles && props.onDropFiles(newFiles);
    }

    return (
        <DropZone
            noClick={noClick}
            multiple={multiple}
            disabled={props.disabled}
            onDrop={(acceptedFiles) => onDropFiles(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
                <div
                    {...getRootProps()}
                    className={`fileUploader-dropZoneContainer ${!props.disabled ? "fileUploader-dropZoneContainerHover" : ""}`}
                >
                    <input {...getInputProps()} />
                    <AttachFileIcon fontSize="large" />
                    {strings.Common.DROP_FILES_HERE}
                </div>
            )}
        </DropZone>
    )
}

export default FileDropZone;